import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Reports_custom_ds_cycle_countService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { warehouse_id?: number, count_ids?: number[] }): 
  Promise<{ result: { TaskId?: number, CreatedSysDateTime?: string, InventoryCountId?: number, ModifiedSysDateTime?: string, PickTaskId?: number, Task?: { Id?: number, ActualInventoryAmount?: number, ActualPackagedAmount?: number, ChainHead?: number, Employee?: string, ExpectedPackagedAmount?: number, ProjectId?: number, ReasonCodeId?: number, StatusId?: number, WarehouseId?: number, Material?: { Description?: string, LookupCode?: string }, VendorLot?: { ExpirationDate?: string }, Project?: { LookupCode?: string, Owner?: { LookupCode?: string } }, Lot?: { LookupCode?: string }, ExpectedSourceLicensePlate?: { LookupCode?: string }, InventoryCountDiscrepancies?: { Id?: number, ActualAmount?: number, ActualCodes?: string, ExpectedAmount?: number, ExpectedCodes?: string, InventoryCountId?: number, ResolvedDatetime?: string, StatusId?: number }[] }, InventoryCount?: { Id?: number, InventoryCountAggregationItems?: number, LookupCode?: string, StatusId?: number, WarehouseId?: number } }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { warehouse_id?: number, count_ids?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { TaskId?: number, CreatedSysDateTime?: string, InventoryCountId?: number, ModifiedSysDateTime?: string, PickTaskId?: number, Task?: { Id?: number, ActualInventoryAmount?: number, ActualPackagedAmount?: number, ChainHead?: number, Employee?: string, ExpectedPackagedAmount?: number, ProjectId?: number, ReasonCodeId?: number, StatusId?: number, WarehouseId?: number, Material?: { Description?: string, LookupCode?: string }, VendorLot?: { ExpirationDate?: string }, Project?: { LookupCode?: string, Owner?: { LookupCode?: string } }, Lot?: { LookupCode?: string }, ExpectedSourceLicensePlate?: { LookupCode?: string }, InventoryCountDiscrepancies?: { Id?: number, ActualAmount?: number, ActualCodes?: string, ExpectedAmount?: number, ExpectedCodes?: string, InventoryCountId?: number, ResolvedDatetime?: string, StatusId?: number }[] }, InventoryCount?: { Id?: number, InventoryCountAggregationItems?: number, LookupCode?: string, StatusId?: number, WarehouseId?: number } }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { warehouse_id?: number, count_ids?: number[], $keys: number[] }): 
  Promise<{ result: { TaskId?: number, CreatedSysDateTime?: string, InventoryCountId?: number, ModifiedSysDateTime?: string, PickTaskId?: number, Task?: { Id?: number, ActualInventoryAmount?: number, ActualPackagedAmount?: number, ChainHead?: number, Employee?: string, ExpectedPackagedAmount?: number, ProjectId?: number, ReasonCodeId?: number, StatusId?: number, WarehouseId?: number, Material?: { Description?: string, LookupCode?: string }, VendorLot?: { ExpirationDate?: string }, Project?: { LookupCode?: string, Owner?: { LookupCode?: string } }, Lot?: { LookupCode?: string }, ExpectedSourceLicensePlate?: { LookupCode?: string }, InventoryCountDiscrepancies?: { Id?: number, ActualAmount?: number, ActualCodes?: string, ExpectedAmount?: number, ExpectedCodes?: string, InventoryCountId?: number, ResolvedDatetime?: string, StatusId?: number }[] }, InventoryCount?: { Id?: number, InventoryCountAggregationItems?: number, LookupCode?: string, StatusId?: number, WarehouseId?: number } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      warehouse_id?: number, count_ids?: number[]    }) {
      return false;
    }
}
